import React, {useEffect, useState} from 'react';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Title from './Title';
import { getDateNow } from './utils/helpers';

function preventDefault(event) {
	event.preventDefault();
}

const useStyles = makeStyles({
	depositContext: {
		flex: 1,
	},
});

export default function Deposits(props) {
	console.log("Deposits")
	

	const classes = useStyles();
	const [sumOfData, setSumOfData] = useState(0);
	const [dateNow, setDateNow] = useState('');
	
	useEffect(() => {
		

		if(props.data && props.data.length){
			const sumData = props.data.reduce((a, b) => a + b.acqCost, 0);
			setSumOfData(sumData);
			const dateNow = getDateNow();
			console.log("dateNow", dateNow);
			setDateNow(dateNow);	
		}
		return () => {
			
		}
	},[props.data])

	return (
		<React.Fragment>
			<Title>Assets</Title>
			<Typography component="div" variant="h5">
				{`Php: ${sumOfData.toLocaleString()}`}
			</Typography>
			
			<Typography component="div" color="textSecondary" className={classes.depositContext}>
				{`on ${dateNow}`}
			</Typography>
			
			<div>
				<Link color="primary" href="#" onClick={preventDefault}>
					<Typography component="div" variant="h5">
						{
							props.data && props.data.length > 0 ?
								`Items: ${props.data.length}`
							:
							null
						}
					</Typography>
				</Link>
			</div>
		</React.Fragment>
	);
}
